module.exports = __webpack_public_path__ + "static/media/BG.67d1f5c2.svg";